import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Poil = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.2 99.39">
  <G fill={color}>
    <Path d="M32.74,89.17c6.85-.59,11.91-6.94,10.81-13.75-1.61-10.5-1.13-21.41.84-31.89,2.95-15.03,9.36-29.32,17.9-42,.69-.92-.58-2.02-1.41-1.28l-3.97,3.57c-5.41,4.8-10.25,10.24-14.7,15.97-7.81,10.44-14.13,22.3-18.11,34.74-2.35,7.65-4.55,15.58-4.4,23.72.59,6.62,6.43,11.51,13.05,10.92Z"/>
    <Path d="M66.97,73.95h-13.93c-3.18,0-5.89,2.27-6.42,5.4-.55,3.19-3.23,13.58-14.94,13.58s-14.4-10.4-14.94-13.58c-.53-3.13-3.24-5.4-6.42-5.4H3.23c-1.78,0-3.23,1.45-3.23,3.23s1.45,3.23,3.23,3.23l7.13.03c1.57,9.16,7.99,18.95,21.31,18.95s19.74-9.79,21.36-18.98h13.93c1.78,0,3.23-1.45,3.23-3.23s-1.45-3.23-3.23-3.23Z"/>
  </G>
</Svg>
);
};

export default Poil;
